module.exports = __webpack_public_path__ + "static/media/ThunderSun11d.667c1623.png";